import React from "react";
import { Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import {
  FaWhatsapp,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";

function Contact() {
  const whatsappNumber = "5519998830413";
  const whatsappMessage =
    "Olá, gostaria de mais informações sobre os sistemas!";
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    whatsappMessage
  )}`;

  return (
    <div style={{ minHeight: "100vh" }}>
      <Container fluid className="resume-section" style={{ padding: "80px 0" }}>
        <Particle />

        <Row
          style={{
            justifyContent: "center",
            position: "relative",
            margin: "40px 0",
          }}
        >
          <h1
            style={{
              color: "white",
              marginBottom: "40px",
              textAlign: "center",
              fontSize: "2.5rem",
            }}
          >
            Entre em <span style={{ color: "#9437e6" }}>Contato</span>
          </h1>
        </Row>

        <Row
          style={{
            justifyContent: "center",
            position: "relative",
            margin: "135px 0",
            minHeight: "300px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "25px",
            }}
          >
            <Button
              variant="success"
              href={whatsappLink}
              target="_blank"
              style={{
                width: "280px",
                padding: "15px 0",
                margin: "0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.1rem",
              }}
            >
              <FaWhatsapp style={{ marginRight: "15px", fontSize: "1.5rem" }} />
              WhatsApp
            </Button>

            <Button
              variant="primary"
              href="mailto:contato.quantumtechbrasil@gmail.com"
              target="_blank"
              style={{
                width: "280px",
                padding: "15px 0",
                margin: "0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.1rem",
              }}
            >
              <FaEnvelope style={{ marginRight: "15px", fontSize: "1.5rem" }} />
              Enviar Email
            </Button>

            <Button
              variant="info"
              href="tel:+5519998830413"
              style={{
                width: "280px",
                padding: "15px 0",
                margin: "0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.1rem",
              }}
            >
              <FaPhoneAlt style={{ marginRight: "15px", fontSize: "1.5rem" }} />
              Ligar Agora
            </Button>

            <Button
              variant="warning"
              href="https://www.google.com/maps/place/Campinas,+SP/"
              target="_blank"
              style={{
                width: "280px",
                padding: "15px 0",
                margin: "0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.1rem",
              }}
            >
              <FaMapMarkerAlt
                style={{ marginRight: "15px", fontSize: "1.5rem" }}
              />
              Campinas, SP
            </Button>
          </div>
        </Row>

        <Row
          style={{
            justifyContent: "center",
            position: "relative",
            margin: "60px 0",
            padding: "30px 0",
          }}
        >
          <div
            style={{
              color: "white",
              textAlign: "center",
              width: "100%",
              maxWidth: "600px",
              background: "rgba(255, 255, 255, 0.1)",
              padding: "30px",
              borderRadius: "15px",
              margin: "20px",
            }}
          >
            <h4 style={{ fontSize: "1.5rem", marginBottom: "20px" }}>
              Horário de Atendimento
            </h4>
            <p style={{ margin: "15px 0", fontSize: "1.1rem" }}>
              Segunda a Sexta: 8h às 18h
            </p>
            <p style={{ fontSize: "1.1rem" }}>Sábado: 8h às 13h</p>
          </div>
        </Row>
      </Container>
    </div>
  );
}

export default Contact;
